import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

function destination(to: RouteLocationNormalized, path: string, query = to.query) {
  return { path, query, hash: to.hash }
}

const serviceCalls: RouteRecordRaw[] = ['appels-de-service', 'service-calls'].flatMap((slug) => [
  ...['', '/list', '/liste'].map((mode) => ({
    path: `manage/${slug}${mode}`,
    redirect: (to: RouteLocationNormalized) => destination(to, '/manage/appels-de-service/list'),
  })),
  ...['edit', 'editer', 'detail', 'preview'].map((mode) => ({
    path: `manage/${slug}/${mode}/:id`,
    // Vue has no formatted document: preview bookmarks open the classic editor.
    redirect: (to: RouteLocationNormalized) => destination(to, `/manage/appels-de-service/edit/${String(to.params.id)}`),
  })),
])

const partners: RouteRecordRaw[] = ['partenaires', 'business-partners', 'fournisseurs', 'fournisseur', 'suppliers', 'supplier'].flatMap((slug) =>
  ['', 'list', 'liste', 'create', 'creer', 'créer', 'cr%C3%A9er'].map((mode) => ({
    path: `manage/${slug}${mode ? `/${mode}` : ''}`,
    redirect: (to: RouteLocationNormalized) => {
      const supplier = !['partenaires', 'business-partners'].includes(slug) || to.query.role === 'supplier'
      const creating = !['', 'list', 'liste'].includes(mode) || to.query.new === '1'
      const query = { ...to.query }
      delete query.role
      delete query.new
      return destination(to, `/manage/${supplier ? 'fournisseurs' : 'partenaires'}/${creating ? 'create' : 'list'}`, query)
    },
  })),
)

const routes: RouteRecordRaw[] = [
  ...serviceCalls,
  { path: 'clients/:id', redirect: (to) => destination(to, `/clients/${String(to.params.id)}`) },
  ...partners,
  // Explicit records must precede the catch-all: route redirects run before guards.
  ...['business-partners', 'partenaires', 'suppliers', 'supplier', 'fournisseurs', 'fournisseur'].flatMap((slug) =>
    ['edit', 'editer'].map((mode) => ({
      path: `manage/${slug}/${mode}/:id`,
      redirect: (to: RouteLocationNormalized) => destination(to, `/clients/${String(to.params.id)}`),
    })),
  ),
  {
    path: 'dashboard/finances',
    redirect: (to) => {
      // Only React reads the workspace view and time window from the URL.
      const query = { ...to.query }
      delete query.view
      delete query.window
      return destination(to, '/dashboard/finances', query)
    },
  },
  {
    path: 'dashboard/parts/:partId?',
    redirect: (to) =>
      destination(to, to.query.view === 'orders' ? '/parts-to-order' : `/dashboard/parts${to.params.partId ? `/${String(to.params.partId)}` : ''}`),
  },
  { path: 'parts-to-order', redirect: (to) => destination(to, '/parts-to-order') },
  { path: 'parts/unsold', redirect: (to) => destination(to, '/dashboard/parts', { ...to.query, lens: 'never_sold' }) },
  { path: '', redirect: '/' },
  { path: ':catchAll(.*)*', redirect: '/' },
]

export default routes
